<script>
  export default {
    name: 'Base',
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
  };
</script>
